<template>
  <div class="grid-center-h-v">
    <v-progress-circular
      :size="32"
      :width="2"
      indeterminate
      color="primary"
    ></v-progress-circular>
  </div>
</template>

<script>
export default {
  name: "Loading",
};
</script>

<style scoped></style>
